module.exports = __webpack_public_path__ + "img/2.5aa8b82a.jpg";